import { render, staticRenderFns } from "./Authorize.vue?vue&type=template&id=62738926&scoped=true"
import script from "./Authorize.vue?vue&type=script&lang=js"
export * from "./Authorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62738926",
  null
  
)

export default component.exports